import { StoredOpinion } from "@/contexts";
import { PollVote, QuizVote, VotingVote } from "@/service/Model";
import { log } from "@/utils/logger";

const LOCAL_STORAGE_PREFIX = "la-interactive-web-interaction-";
const LOCAL_STORAGE_SUFFIX = "-participation";

class LocalStorageService {
  public static setVotes(
    interactionId: string,
    votes: PollVote[] | QuizVote[] | VotingVote[] | undefined
  ): void {
    this.set(LOCAL_STORAGE_PREFIX + interactionId, votes, true);
  }

  public static getVotes(
    interactionId: string
  ): PollVote[] | QuizVote[] | VotingVote[] {
    return this.get(LOCAL_STORAGE_PREFIX + interactionId, true, []);
  }

  public static setOpinion(
    interactionId: string,
    opinion?: StoredOpinion
  ): void {
    this.set(LOCAL_STORAGE_PREFIX + interactionId, opinion, true);
  }

  public static getOpinion(interactionId: string): StoredOpinion | undefined {
    const opinion = this.get(LOCAL_STORAGE_PREFIX + interactionId, true);
    if (opinion != null) {
      return opinion;
    }
    return undefined;
  }

  public static removeOpinion(interactionId: string): void {
    this.remove(LOCAL_STORAGE_PREFIX + interactionId);
  }

  public static setParticipation(interactionId: string, action: boolean): void {
    return this.set(
      LOCAL_STORAGE_PREFIX + interactionId + LOCAL_STORAGE_SUFFIX,
      action
    );
  }

  public static getParticipation(interactionId: string): boolean {
    return Boolean(
      this.get(
        LOCAL_STORAGE_PREFIX + interactionId + LOCAL_STORAGE_SUFFIX,
        true
      )
    );
  }

  private static get(key: string, parseJSON?: boolean, fallback?: any): any {
    try {
      if (parseJSON) {
        const parsed = JSON.parse(window.localStorage.getItem(key) || `"{}"`);
        return typeof parsed === "string" ? fallback : parsed;
      }
      return window.localStorage.getItem(key);
    } catch (e) {
      log.error("Error while get item from local storage: " + e);
    }
  }

  private static set(key: string, value: any, stringify?: boolean): void {
    try {
      if (stringify) {
        value = JSON.stringify(value);
      }
      window.localStorage.setItem(key, value);
    } catch (e) {
      log.error("Error while set item to local storage: " + e);
    }
  }

  private static remove(key: string): void {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      console.error("localStorage Exception", e);
    }
  }
}

export default LocalStorageService;
